import Jobs from './Jobs.react'

export default Jobs
